module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter"
  }, [_c('strong', [_c('em', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/prologue"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PROLOGUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/part01"
    }
  }, [_vm._v("FRIDAY, MAY 2, 1902")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap01"
    }
  }, [_vm._v("1. The First Victim")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap02"
    }
  }, [_vm._v("2. The Anxious Bridegroom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap03"
    }
  }, [_vm._v("3. A Cell with a View")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SATURDAY, MAY 3, 1902")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Tumbled from Bed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Lava in the Throat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Whole World in Flood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUNDAY, MAY 4, 1902")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Special Powers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. A Black Mass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Prison Riot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Released to the Living")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONDAY, MAY 5, 1902")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Pavement Slaughterhouse 133")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. A Mountain on the March 145")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Great Wave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. A Shortage of Coffins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TUESDAY, MAY 6, 1902")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Sympathy of the Government")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. A Handful of Francs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. The Deepening Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. A Fateful Reprieve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Stars and Stripes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEDNESDAY, MAY 7, 1902")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Gabriel’s Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The End of the Affair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THURSDAY, MAY 8, 1902")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. "), _c('em', [_vm._v("“Allez”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Requiem for the Living")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EPILOGUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/authorsnote"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUTHOR’S NOTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/background",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BACKGROUND TO THE BOOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/chap07#img1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Illustrations follow")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a1bd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/contents.vue
// module id = 69
// module chunks = 0